import { DataFile } from "interfaces";
import { useFetchDeducedColumnTypes } from "modules/data-files/api";

interface Props {
  selectedFile: DataFile.DataFile;
  label?: string;
}

const ColumnsInFile = ({ selectedFile, label }: Props) => {
  useFetchDeducedColumnTypes(selectedFile.id);
  return (
    <div className="mt-2">
      <div className="flex flex-wrap items-center">
        {label ? (
          label
        ) : (
          <span className="font-semibold italic">Columns in File: </span>
        )}
        {selectedFile.columns?.map((c) => (
          <div
            key={c}
            className="flex justify-center items-center m-1 font-medium py-1 px-2 rounded-full text-gray-700 bg-gray-200 border border-gray-300 "
          >
            <div className="text-xs font-semibold leading-none max-w-full flex-initial">
              {c}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ColumnsInFile;
